import { select } from "redux-saga/effects";
import { get } from "lodash";
import { googleAnalyticsScript } from "../../../analytics";

export default function* complianceFinished() {
  const allowAnalytics = yield select((state) =>
    get(state, "cookieCompliance.analytics")
  );

  if (!allowAnalytics) {
    return;
  }
  yield googleAnalyticsScript();
}
